import { FC, useEffect, useMemo, useState } from "react";
import { TextField, useForm } from "@refinedev/antd";
import { AppViewCard } from "../../../../../components";
import { errorNotification, successNotification } from "../../../../../helpers";
import { CloseOutlined, EditOutlined } from "@ant-design/icons";
import { Button, Form, InputNumber, Space } from "antd";
import s from "./Clubs-Change-Stadium-Capacity.module.scss";

type ClubsChangeStadiumCapacityProps = {
  teamFnlId?: string;
  stadiumCapacity?: number | null;
  onRefetchCard: () => void;
};

type StadiumCapacityFormValues = {
  teamFnlId: string;
  stadiumCapacity: number;
};

export const ClubsChangeStadiumCapacity: FC<
  ClubsChangeStadiumCapacityProps
> = ({ teamFnlId, stadiumCapacity, onRefetchCard }) => {
  const [edit, setEdit] = useState(false);

  const canEdit = useMemo(() => Boolean(teamFnlId), [teamFnlId]);

  const { formProps, form } = useForm<StadiumCapacityFormValues>({
    action: "create",
    resource: "clubs",
    dataProviderName: "clubsStadiumCapacityDataProvider",
    redirect: false,
    ...successNotification({
      successData: {
        message: "Вместимость стадиона сохранена",
        type: "success",
      },
      callback: () => {
        setEdit(false);
        onRefetchCard();
      },
    }),
    ...errorNotification({}),
  });

  useEffect(() => {
    if (!edit) {
      form.setFieldsValue({
        teamFnlId: teamFnlId ?? "",
        stadiumCapacity: stadiumCapacity ?? undefined,
      });
    }
  }, [edit, form, stadiumCapacity, teamFnlId]);

  const handleEdit = () => {
    if (!canEdit) return;
    setEdit(true);
  };

  const handleStopEdit = () => {
    setEdit(false);
    form.setFieldValue("stadiumCapacity", stadiumCapacity ?? undefined);
  };

  return (
    <>
      {!edit ? (
        <AppViewCard label={"Вместимость стадиона:"}>
          <Space
            direction={"horizontal"}
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "space-between",
            }}
            size={24}
          >
            <TextField value={stadiumCapacity ?? "–"} />
            <div className={s.wrapContainer}>
              <EditOutlined
                style={{
                  fontSize: 20,
                  cursor: canEdit ? "pointer" : "not-allowed",
                  color: canEdit ? "var(--accent-main)" : "#BFBFBF",
                }}
                onClick={handleEdit}
              />
            </div>
          </Space>
        </AppViewCard>
      ) : (
        <div
          style={{
            width: "100%",
            display: "flex",
            justifyContent: "space-between",
            gap: 16,
          }}
        >
          <Form
            style={{
              width: "100%",
              display: "flex",
              gap: 8,
            }}
            {...formProps}
            initialValues={{
              teamFnlId: teamFnlId ?? "",
              stadiumCapacity: stadiumCapacity ?? undefined,
            }}
            layout={"horizontal"}
          >
            <Form.Item name={"teamFnlId"} hidden />
            <Form.Item
              name={"stadiumCapacity"}
              style={{ width: "100%" }}
              rules={[
                { required: true, message: "Укажите вместимость стадиона" },
              ]}
            >
              <InputNumber
                style={{ width: "100%" }}
                min={0}
                precision={0}
                placeholder={"Укажите вместимость"}
              />
            </Form.Item>
            <Button type={"primary"} htmlType={"submit"}>
              Сохранить
            </Button>
            <div className={s.iconContainer}>
              <CloseOutlined
                style={{
                  fontSize: 20,
                  cursor: "pointer",
                  color: "var(--accent-main)",
                }}
                onClick={handleStopEdit}
              />
            </div>
          </Form>
        </div>
      )}
    </>
  );
};
